// extracted by mini-css-extract-plugin
module.exports = {"back-to-licences":"styles__back-to-licences___1jiAs"};